import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
declare const BadgePlugin: any;

@Injectable({
  providedIn: 'root'
})
export class BadgeService {

  constructor(private platform: Platform) { }

  /**
  * Set badge number
  */
  async setBadge(number: number): Promise<void> {
    await BadgePlugin.set(number);
  }

  /**
   * Clear badge
   */
  async clearBadge(): Promise<void> {
    await this.platform.ready();

    return new Promise((resolve, reject) => {
      // if (typeof cordova !== 'undefined' && cordova.plugins && cordova.plugins.badge) {
      //   cordova.plugins.badge.clear(resolve, reject);
      // } else {
      //   reject('Badge plugin not available');
      // }
    });
  }

  /**
   * Get badge number
   */
  async getBadge(): Promise<number> {
    await this.platform.ready();

    return new Promise((resolve, reject) => {
      // if (typeof cordova !== 'undefined' && cordova.plugins && cordova.plugins.badge) {
      //   cordova.plugins.badge.get(resolve, reject);
      // } else {
      //   reject('Badge plugin not available');
      // }
    });
  }

  /**
   * Check if badges are supported
   */
  async isSupported(): Promise<boolean> {
    await this.platform.ready();

    return new Promise((resolve) => {
      // if (typeof cordova !== 'undefined' && cordova.plugins && cordova.plugins.badge) {
      //   cordova.plugins.badge.hasPermission((hasPermission: boolean) => {
      //     resolve(hasPermission);
      //   });
      // } else {
      //   resolve(false);
      // }
    });
  }

  /**
   * Request permission for badges
   */
  async requestPermission(): Promise<boolean> {
    await this.platform.ready();

    return new Promise((resolve, reject) => {
      // if (typeof cordova !== 'undefined' && cordova.plugins && cordova.plugins.badge) {
      //   cordova.plugins.badge.requestPermission((hasPermission: boolean) => {
      //     resolve(hasPermission);
      //   }, reject);
      // } else {
      //   reject('Badge plugin not available');
      // }
    });
  }
}
